import type { ReactNode } from 'react'

import { useT } from '@/i18n'

export function EmptyState({ title, description }: { title: string; description?: ReactNode }) {
  return (
    <div className="px-8 py-12 text-center">
      <h3 className="text-2xl font-extrabold text-ink">{title}</h3>
      {description && <p className="mt-2 text-[15px] text-ink-muted">{description}</p>}
    </div>
  )
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  const t = useT()
  return (
    <div className="px-8 py-10 text-center">
      <p className="text-[15px] text-ink-muted">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 px-corners bg-brand px-4 py-2 text-sm font-bold text-on-brand hover:bg-brand-hover"
        >
          {t('ui.retry')}
        </button>
      )}
    </div>
  )
}
